const ReportPageProposalFactSheet = ({ financialProductName }) => {
  const getAssetsFolder = productName => {
    if (!productName) return;

    if (productName.includes("ETF")) return "ETF";

    if (
      productName.includes("Peak") &&
      productName.includes("Core") &&
      productName.includes("Alts")
    )
      return "Peak  with Alts";

    if (productName.includes("Peak") && productName.includes("Core"))
      return "Peak Core";

    if (
      productName.includes("Peak") &&
      productName.includes("Elite") &&
      productName.includes("Alts")
    )
      return "Peak Elite with Alts";

    if (productName.includes("Peak") && productName.includes("Elite"))
      return "Peak Elite";

    if (productName.includes("Strategic") && productName.includes("Core"))
      return "Strategic Core";

    if (productName.includes("Strategic") && productName.includes("Elite"))
      return "Strategic Elite";
  };

  return (
    <div id="reportPageProposalFactSheet">
      {new Array(6).fill(null).map((it, index) => (
        <img
          alt="Report Page Proposal Disclosure"
          key={index}
          src={`/assets/oneascent/pdf/factSheet/${getAssetsFolder(financialProductName)}/page${
            index + 1
          }.jpg`}
          style={{
            margin: "0 15px",
            width: 1200,
          }}
        />
      ))}
    </div>
  );
};

export default ReportPageProposalFactSheet;
